import React from 'react';
import { Leaf, Moon, ThermometerSnowflake, Soup, Activity, Heart, Brain, Sparkles, Flower2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
const categories = [{
  icon: Activity,
  label: 'Inflamación y dolores',
  count: '42 remedios'
}, {
  icon: Moon,
  label: 'Ansiedad y sueño',
  count: '38 remedios'
}, {
  icon: ThermometerSnowflake,
  label: 'Resfriados y defensas',
  count: '35 remedios'
}, {
  icon: Soup,
  label: 'Digestión',
  count: '33 remedios'
}, {
  icon: Heart,
  label: 'Articulaciones y huesos',
  count: '29 remedios'
}, {
  icon: Brain,
  label: 'Estrés y cansancio',
  count: '31 remedios'
}, {
  icon: Sparkles,
  label: 'Piel y circulación',
  count: '28 remedios'
}, {
  icon: Flower2,
  label: 'Bienestar general',
  count: '40+ remedios'
}];
const sampleRemedies = [{
  title: 'Infusión de manzanilla y melisa',
  use: 'Relajación antes de dormir',
  time: '5 min'
}, {
  title: 'Compresa tibia de jengibre',
  use: 'Dolor muscular y articular',
  time: '10 min'
}, {
  title: 'Vapor de eucalipto y tomillo',
  use: 'Congestión y resfriados',
  time: '7 min'
}, {
  title: 'Té digestivo de hinojo',
  use: 'Hinchazón y malestar estomacal',
  time: '5 min'
}];
export function InsideGuide() {
  return <section className="py-12 md:py-20 px-5 bg-cream-100 texture-paper" data-id="element-160">
      <div className="max-w-5xl mx-auto" data-id="element-161">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14 max-w-2xl mx-auto" data-id="element-162">
          <p className="text-xs uppercase tracking-[0.2em] text-olive-600 font-medium mb-4" data-id="element-163">
            Qué vas a encontrar adentro
          </p>
          <h2 className="font-serif font-medium text-3xl md:text-5xl text-ink-900 leading-tight mb-5" data-id="element-164">
            Una biblioteca natural completa,{' '}
            <span className="italic text-olive-600" data-id="element-165">
              organizada por síntoma
            </span>
          </h2>
          <p className="text-ink-700 text-base md:text-lg leading-relaxed" data-id="element-166">
            Buscás lo que te pasa, encontrás el remedio, ves cómo prepararlo.
            Sin vueltas, sin información mezclada de internet.
          </p>
        </div>

        {/* Categories grid */}
        <div className="mb-10 md:mb-14" data-id="element-167">
          <p className="text-center text-sm font-medium text-ink-600 mb-6 uppercase tracking-wider" data-id="element-168">
            9 categorías principales
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-169">
            {categories.map((cat, idx) => {
            const Icon = cat.icon;
            return <div key={idx} className="bg-cream-50 border border-cream-300 rounded-2xl p-4 md:p-5 hover:border-olive-300 hover:shadow-md transition-all" data-id="element-170">
                  <div className="w-10 h-10 rounded-xl bg-olive-100 flex items-center justify-center mb-3" data-id="element-171">
                    <Icon className="w-5 h-5 text-olive-600" strokeWidth={1.8} data-id="element-172" />
                  </div>
                  <p className="font-serif text-sm md:text-base font-medium text-ink-900 leading-tight mb-1" data-id="element-173">
                    {cat.label}
                  </p>
                  <p className="text-xs text-ink-600" data-id="element-174">{cat.count}</p>
                </div>;
          })}
          </div>
        </div>

        {/* Sample remedy cards — gives "feel" of the inside */}
        <div className="mb-10 md:mb-14" data-id="element-175">
          <p className="text-center text-sm font-medium text-ink-600 mb-6 uppercase tracking-wider" data-id="element-176">
            Un vistazo a algunas recetas
          </p>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-177">
            {sampleRemedies.map((r, idx) => <div key={idx} className="bg-cream-50 border border-cream-300 rounded-2xl p-5 flex items-start gap-4" data-id="element-178">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-olive-600 flex items-center justify-center" data-id="element-179">
                  <Leaf className="w-6 h-6 text-cream-50" strokeWidth={1.8} data-id="element-180" />
                </div>
                <div className="flex-1" data-id="element-181">
                  <h4 className="font-serif font-medium text-ink-900 text-base md:text-lg leading-snug mb-1" data-id="element-182">
                    {r.title}
                  </h4>
                  <p className="text-sm text-ink-700 mb-2" data-id="element-183">{r.use}</p>
                  <span className="inline-block text-xs font-medium text-olive-700 bg-olive-50 px-2 py-0.5 rounded-full" data-id="element-184">
                    Preparación: {r.time}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Stats strip */}
        <div className="bg-olive-600 text-cream-50 rounded-3xl p-8 md:p-10 grid grid-cols-3 gap-4 text-center mb-8 md:mb-12" data-id="element-185">
          <div data-id="element-186">
            <p className="font-serif text-3xl md:text-5xl font-medium" data-id="element-187">300+</p>
            <p className="text-xs md:text-sm text-cream-200 mt-1" data-id="element-188">Remedios</p>
          </div>
          <div className="border-x border-olive-500" data-id="element-189">
            <p className="font-serif text-3xl md:text-5xl font-medium" data-id="element-190">9</p>
            <p className="text-xs md:text-sm text-cream-200 mt-1" data-id="element-191">Categorías</p>
          </div>
          <div data-id="element-192">
            <p className="font-serif text-3xl md:text-5xl font-medium" data-id="element-193">10</p>
            <p className="text-xs md:text-sm text-cream-200 mt-1" data-id="element-194">
              Bonos extra
            </p>
          </div>
        </div>

        <CTAButton data-id="element-195" />
      </div>
    </section>;
}